<template>
  <div>
    <p>I grafen ser du hur många personer som varit inskrivna för sjukhusvård dag för dag. Uppgifterna finns från och med 25 mars.</p>
    <highcharts :options="chartOptions"></highcharts>
  </div>
</template>

<script>
import Highcharts from 'highcharts'
import dataModule from 'highcharts/modules/data'
dataModule(Highcharts)

export default {
  name: 'HospitalChart',
  components: {
  },
  props: {
    articleUrl: String,
    region: {
      type: String,
      default: 'world',
    },
  },
  data() {
    return {
      series: null,
    }
  },
  computed: {
    chartOptions() {
      return {
        chart: {
          height: 250,
          type: 'area',
          spacing: [12, 2, 2, 2],
        },
        colors: ['#ffd382', '#ff7800'],
        data: {
          csvURL: (process.env.NODE_ENV === 'production' ? 'https://svenska-dataviz.ylestatic.fi/2020-03-corona/' : 'http://local.yle.fi:8080/data/') + 'hospitalized.csv',
          itemDelimiter: ',',
          lineDelimiter: '\n',
          complete: (options) => {
            this.series = options.series;
          },
        },
        title: false,
        subtitle: false,
        credits: {
          enabled: false,
        },
        legend: {
          floating: true,
          align: 'left',
          verticalAlign: 'top',
          x: 40,
          symbolRadius: 0,
          itemStyle: {
            fontWeight: 'normal',
          },
        },
        xAxis: {
          type: 'datetime',
          tickmarkPlacement: 'on',
          tickPixelInterval: 140,
          title: {
            enabled: false,
          },
          min: Date.UTC(2020, 2, 25),
          plotLines: [{
            value: Date.UTC(2020, 11, 7),
            color: '#999',
            width: 2,
            dashStyle: 'ShortDash',
            label: {
              text: 'THL ändrar rapporteringen<br>av avdelningsvårdade',
              rotation: 0,
              textAlign: 'right',
              y: 35,
              x: -5,
            }
          }],
        },
        yAxis: {
          title: false,
          labels: {
            align: 'left',
            x: 0,
            y: -3,
          },
        },
        plotOptions: {
          area: {
            stacking: 'normal',
          },
        },
        tooltip: {
          shared: true,
        },
      }
    }
  },
}
</script>
